var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, CircularProgress } from '@mui/material';
import { styled, useTheme } from '@mui/system';
import { BsPauseFill, BsPlayFill } from 'react-icons/bs';
import { useKeyPressEvent } from 'react-use';
import { usePreviewMode } from '../../hooks/usePreviewMode';
import { createKeypadButton } from './createKeypadButton';
export function Keypad(props) {
    var buttonSize = props.buttonSize, previewMode = props.previewMode, setValue = props.setValue, hidePauseButton = props.hidePauseButton, _a = props.keys, keys = _a === void 0 ? ['1', '2', '3', '4', '5', '6', '7', '8', '9', null, '0', null] : _a, onSubmit = props.onSubmit;
    useKeyPressEvent('Enter', onSubmit);
    var theme = useTheme();
    var _b = usePreviewMode(previewMode, setValue), togglePaused = _b.togglePaused, paused = _b.paused, state = _b.state;
    if (!state.initialized && previewMode)
        return (_jsx("div", __assign({ className: "grid place-items-center min-h-[10rem]" }, { children: _jsx(CircularProgress, {}) })));
    return (_jsxs(_Fragment, { children: [_jsx(KeypadWrapper, __assign({ tabIndex: 0, role: "application", "aria-label": "number pad", buttonSize: buttonSize }, { children: keys.map(function (key, index) { return createKeypadButton(key, index, theme, props); }) })), previewMode && !hidePauseButton && (_jsx(Button, __assign({ onClick: togglePaused }, { children: paused ? (_jsx(BsPlayFill, { size: '2rem' })) : (_jsx(BsPauseFill, { size: '2rem' })) })))] }));
}
export default Keypad;
var KeypadWrapper = styled('div', {
    shouldForwardProp: function (prop) { return prop !== 'buttonSize'; },
})(function (_a) {
    var buttonSize = _a.buttonSize;
    return ({
        display: 'grid',
        gridTemplateColumns: "repeat(3, minmax(0, ".concat(buttonSize === 'small' ? '60px' : '80px', "))"),
        gridTemplateRows: "repeat(4, minmax(0, ".concat(buttonSize === 'small' ? '60px' : '80px', "))"),
        placeContent: 'center',
        placeItems: 'center',
        '& *': {
            margin: buttonSize === 'small' ? '.4rem' : '.5rem',
        },
        '& button': {
            fontSize: buttonSize === 'small' ? '1rem' : '1.3rem',
        },
    });
});
